
export enum VoucherAttachmentType {
  LoupeGiftCard = 'LOUPE_GIFT_CARD',
  LoupeOpenTicketPass = 'LOUPE_OPEN_TICKET_PASS',
}
